import {
  BankGateway,
  CustomerPurchaseDepositDto,
} from "@/models/club";
import { bankGatewayLabel } from "@/services/payment/bankGateway";
import { Badge, Group, Stack, Text } from "@mantine/core";

const money = (value?: number | null) =>
  typeof value === "number" ? value.toLocaleString("fa-IR") : "۰";

const gatewayColor = (gateway?: BankGateway) =>
  gateway === BankGateway.Value4 ? "violet" : "blue";

export function DepositGatewayBadge({
  gateway,
  amount,
  showAmount = true,
}: {
  gateway?: BankGateway;
  amount?: number;
  showAmount?: boolean;
}) {
  return (
    <Badge color={gatewayColor(gateway)} variant="light" size="sm">
      {bankGatewayLabel(gateway)}
      {showAmount ? ` · ${money(amount)} ریال` : ""}
    </Badge>
  );
}

export function InvoiceDepositSummary({
  deposits: rawDeposits,
}: {
  deposits?: CustomerPurchaseDepositDto[] | null;
}) {
  const deposits = rawDeposits ?? [];
  const totals = deposits.reduce<Map<BankGateway | undefined, number>>(
    (result, deposit) => {
      result.set(
        deposit.bankGateway,
        (result.get(deposit.bankGateway) || 0) + (deposit.amount || 0),
      );
      return result;
    },
    new Map(),
  );
  const totalAmount = deposits.reduce(
    (sum, deposit) => sum + (deposit.amount || 0),
    0,
  );

  if (deposits.length === 0) {
    return <Text size="xs" c="dimmed">بدون پیش‌پرداخت</Text>;
  }

  return (
    <Stack gap={4} align="center">
      <Text size="sm" fw={800}>{money(totalAmount)} ریال</Text>
      <Group gap={4} justify="center">
        {[...totals.entries()].map(([gateway, amount]) => (
          <DepositGatewayBadge
            key={gateway ?? "unknown"}
            gateway={gateway}
            amount={amount}
          />
        ))}
      </Group>
    </Stack>
  );
}
